// import { About, Self, Collection, Cury, Links, Guid, Title, Content, Excerpt } from './common';
import { Address } from './address';
import { Role } from './role';

export class AvatarUrls {
    24: string;
    48: string;
    96: string;
}

export class UserToken {
    user: User;
    token: string;
    expiration: string;
    organization: Organization;
}

export class User {
    id?: any;
    firstName: string;
    lastName: string;
    userName: string;
    email: string;
    role: Role;
    avatarUrl?: any;
    password?: any;
    billingId: string;
    channelId: number;
    subscriptionId: string;
    planType: string;
    subscriptionStatus: string;
    paymentMethodId: string;
    balance: number;
    toRemove: boolean;
    freeTrial: boolean;
    subscriptionEndDate: string;
    timeZone: string;
    isDeleted: boolean;
    currentOrganizationId?: number;
    personalOrganizationId?: number;
    subscriptionInterval?: string;
  }

export interface Organization {
  id?: number;
  name?: string;
  billingKey?: string;
  email?: string;
  phoneNumber?: string;
  addressId?: number | null;
  website?: string | null;
  createdDate?: string;
  modifiedDate?: string;
  slug?: string;
  defaultTimezone?: any;
  defaultInviteRole?: 'BillingOwner' |'Owner' | 'Admin' | 'Member' | 'Viewer';
  logoUrl?: string | null;
  isPersonal?: boolean;
  stripeCustomerId?: string | null;
  createdByUserId?: string;
  billingOwnerUserId?: string | null;
  billingId?: string | null; // maps to StripeCustomerId or BillingId
  subscriptionInterval?: string | null;
  subscriptionId?: string | null;
  subscriptionStatus?: string | null;
  freeTrial?: boolean;
  subscriptionEndDate?: string | null;
  orgProperty?: OrgProperty[];
  address?: Address | null;
}

export interface OrgProperty {
  id?: number;
  key?: string;
  value?: string;
}

export interface OrganizationContext {
  organization: Organization;
  currentOrganizationId: number;
}

export interface MyOrg {
    id: number;
    name: string;
    role?: 'BillingOwner' |'Owner' | 'Admin' | 'Member' | 'Viewer';
    slug: string;
    status?: string;
}
